module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 138
// module chunks = 1